import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import(/* webpackChunkName: "about" */ '../views/Index/index.vue'),
      },
      //一对一红娘
      {
        path: 'huechys',
        name: 'Huechys',
        component: () => import(/* webpackChunkName: "about" */ '../views/Huechys/index.vue'),
      },
      //情感交流
      {
        path: 'emotion',
        name: 'Emotion',
        component: () => import(/* webpackChunkName: "about" */ '../views/Emotion/index.vue'),
      },
      //缘分大厅
      {
        path: 'luck',
        name: 'Luck',
        component: () => import(/* webpackChunkName: "about" */ '../views/Luck/index.vue'),
      },
      //活动
      {
        path: 'activity',
        name: 'Activity',
        component: () => import(/* webpackChunkName: "about" */ '../views/Activity/index.vue'),
      },
      //关于我们
      {
        path: 'about',
        name: 'About',
        component: () => import(/* webpackChunkName: "about" */ '../views/About/index.vue'),
      },
      //我的芒果
      {
        path: 'me',
        name: 'Me',
        component: () => import(/* webpackChunkName: "about" */ '../views/Me/index.vue'),
      },
      //注册
      {
        path: 'register',
        name: 'Register',
        component: () => import(/* webpackChunkName: "about" */ '../views/Register/index.vue'),
      },
      //申请入会
      {
        path: 'applyInitiation',
        name: 'ApplyInitiation',
        component: () => import(/* webpackChunkName: "about" */ '../views/ApplyInitiation/index.vue'),
      },
      //忘记密码
      {
        path: 'forget',
        name: 'Forget',
        component: () => import(/* webpackChunkName: "about" */ '../views/Forget/index.vue'),
      },
      //情感案例详情
      {
        path: 'caseMessage',
        name: 'CaseMessage',
        component: () => import(/* webpackChunkName: "about" */ '../views/CaseMessage/index.vue'),
      },
      //会员权益
      {
        path: 'equity',
        name: 'Equity',
        component: () => import(/* webpackChunkName: "about" */ '../views/Equity/index.vue'),
      },
      //我的订单
      {
        path: 'myOrder',
        name: 'MyOrder',
        component: () => import(/* webpackChunkName: "about" */ '../views/MyOrder/index.vue'),
      },
      //会员详情
      {
        path: 'vipMessage',
        name: 'VipMessage',
        component: () => import(/* webpackChunkName: "about" */ '../views/VipMessage/index.vue'),
      },
      //情感交流详情详情
      {
        path: 'emotionMessage',
        name: 'EmotionMessage',
        component: () => import(/* webpackChunkName: "about" */ '../views/EmotionMessage/index.vue'),
      },
      //活动详情
      {
        path: 'activityMessage',
        name: 'ActivityMessage',
        component: () => import(/* webpackChunkName: "about" */ '../views/ActivityMessage/index.vue'),
      },
      //轮播图详情
      {
        path: 'bannerMessage',
        name: 'BannerMessage',
        component: () => import(/* webpackChunkName: "about" */ '../views/bannerMessage/index.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login/index.vue'),
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
router.afterEach(() => {
  window.scrollTo(0, 0)
})
export default router
